import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import VueSimpleAlert from "vue-simple-alert";

Vue.use(VueSimpleAlert);

import VueFormulate from '@braid/vue-formulate'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { es } from '@braid/vue-formulate-i18n'
Vue.use(VueFormulate,  {
  plugins: [ es ],
  locale: 'es'
})

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.use(VueFormulate)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
